import type { DataItemCode } from '../types/secs';

interface DataItemCodesTableProps {
  codes: DataItemCode[];
}

export default function DataItemCodesTable({ codes }: DataItemCodesTableProps) {
  if (!codes || codes.length === 0) return null;

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b-2 border-[var(--color-border)]">
            <th className="text-left py-2 px-4 font-semibold text-xs uppercase tracking-wide text-[var(--color-text-tertiary)]">
              Value
            </th>
            <th className="text-left py-2 px-4 font-semibold text-xs uppercase tracking-wide text-[var(--color-text-tertiary)]">
              Meaning
            </th>
          </tr>
        </thead>
        <tbody>
          {codes.map((code, index) => (
            <tr
              key={`${code.value}-${index}`}
              className="border-b border-[var(--color-border)] last:border-b-0 hover:bg-[var(--color-bg-tertiary)] transition-colors"
            >
              <td className="py-2 px-4 font-mono text-sm whitespace-nowrap">{code.value}</td>
              <td className="py-2 px-4 text-sm text-[var(--color-text-secondary)]">{code.meaning}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
